import * as React from 'react';

/*
 * hopsital Managers manage their team
 * Note: did minimal renaming from the UserManage component
 */
import { Badge, Button } from 'react-bootstrap';

import ReactTable, {
    Column,
    FinalState,
    RowInfo,
    SortingRule
} from 'react-table';
import {
    bulkUpdateInstallProducts,
    clearSelectedInstallBaseID,
    clearSelectedProductID,
    getProductInfo,
    initInventory,
    INVENTORY_EXPORT_DATE_FORMAT,
    moveFacilitiesAPI,
    requestQuote,
    setSearchNewProductsSelectedProduct,
    setSelectedInstallBaseID,
    setSelectedProductID,
    setTableFilter,
    toggleEditInstallModal,
    toggleEditProductModal,
    toggleImportInstallModal,
    toggleSearchNewProductsModal
} from '../../actions/manageInventoryActions';
import { getWorkOrders } from '../../actions/manageWorkOrderActions';
import {
    Ifacility,
    IinstallBase,
    IinstallBasePopulated,
    ImanageInventoryReducer,
    IMaterial,
    IproductInfo,
    IsearchNewProductInstallBatchMode,
    Itile,
    Iuser
} from '../../models';
import {
    emptyTile,
    initialMaterial,
    initialProductQueueObject
} from '../../reducers/initialState';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TFunction } from 'i18next';
import { useState, useCallback } from 'react';
import { FieldConfig } from 'react-reactive-form';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { RouteComponentProps } from 'react-router-dom';
import {
    HIDE_MODAL_EDIT_PRODUCT,
    HIDE_MODAL_SEARCH_NEW_PRODUCTS
} from '../../actions/actionTypes';
import { closeAllModals } from '../../actions/commonActions';
import { getFacility } from '../../actions/manageLocationActions';
import { toggleShoppingCartModal } from '../../actions/shoppingCartActions';
import API from '../../constants/apiEndpoints';
import { constants } from '../../constants/constants';
import { capWords } from '../../helpers/stringHelpers';
import { measurementPointResultStatusTypesEnum } from '../../models-enums';
import { getIsMobile } from '../../reducers/configReducer';
import { Banner } from '../common/Banner';
import { ExportRequest } from '../common/ExportToExcelButton';
import { FormUtil } from '../common/FormUtil';
import useFiltersHeight from '../common/useFiltersHeight';
// import SearchTableForm from '../common/SearchTableForm';
// import { SelectFacilityContainer } from '../common/SelectFacilityContainer';
import { TableUtil } from '../common/TableUtil';
import { WorkOrderExpander } from '../dashboard/WorkOrderExpander';
import { EditWorkOrderModal } from '../manageWorkOrder/EditWorkOrderModal';
import { WorkOrderCloseModal } from '../manageWorkOrder/WorkOrderCloseModal';
import ShoppingCartForm from '../shoppingCart/ShoppingCartForm';
import ShoppingCartModal from '../shoppingCart/ShoppingCartModal';
import BulkStatusChangeModal from './BulkStatusChangeModal';
import EditInstallModal from './EditInstallModal';
import EditProductModal from './EditProductModal';
import ImportInstallModal from './ImportInstallModal';
import { InstallBasesExpanderContainer } from './InstallBasesExpanderContainer';
import InstallContactModal from './InstallContactModal';
import { MPResultHistoryModal } from './MPResultHistoryModal';
import { MPResultListModal } from './MPResultListModal';
import { MPResultListNotesModal } from './MPResultNotesModal';
import SearchNewFacilityModal from './SearchNewFacilityModal';
import SearchNewProductsModal from './SearchNewProductsModal';
import { MPResultHistoryMobileModal } from './mobile/MPResultHistoryMobileModal';
import { MPResultListMobileModal } from './mobile/MPResultListMobileModal';
import { MPResultListNotesMobileModal } from './mobile/MPResultNotesMobileModal';
import ManageInventoryDetails from './mobile/ManageInventoryDetails';
import NewInventorySearch from './NewInventorySearch';
import { useTranslation } from 'react-i18next';

interface Iprops extends RouteComponentProps<any> {
    // Add your regular properties here

    t: TFunction;
    loading: boolean;
    manageInventory: ImanageInventoryReducer;
    toggleEditProductModal: typeof toggleEditProductModal;
    toggleEditInstallModal: typeof toggleEditInstallModal;
    toggleShoppingCartModal: typeof toggleShoppingCartModal;
    toggleSearchNewProductsModal: typeof toggleSearchNewProductsModal;
    toggleImportInstallModal: typeof toggleImportInstallModal;
    getProductInfo: typeof getProductInfo;
    getFacility: typeof getFacility;
    toggleSecurityFunctionsModal: () => void;
    initInventory: typeof initInventory;
    closeAllModals: typeof closeAllModals;
    productInfo: IproductInfo;
    user: Iuser;
    cartTotal: number;
    tableData: any;
    setTableFilter: typeof setTableFilter;
    selectedProduct: IMaterial;
    searchNewProductsSelectedProduct: IMaterial;
    requestQuote: typeof requestQuote;
    selectedFacility: Ifacility;
    selectedInstallBase: IinstallBase;
    setSelectedProductID: typeof setSelectedProductID;
    clearSelectedProductID: typeof clearSelectedProductID;
    setSelectedInstallBaseID: typeof setSelectedInstallBaseID;
    clearSelectedInstallBaseID: typeof clearSelectedInstallBaseID;
    setSearchNewProductsSelectedProduct: typeof setSearchNewProductsSelectedProduct;
    canEditInstalls: boolean;
    canRequestQuote: boolean;
    bannerTitle: string;
    className: string;
    showEditWorkOrderModal: boolean;
    toggleEditWorkOrderModal: () => any;
    showWorkOrderCloseModal: boolean;
    mergeProduct: (sprod: string, dproduct: string) => Promise<void>;
}

export interface Istate {
    selectedRow: any;
    currentTile: Itile;
    showSearchNewFacilityModal: boolean;
    installIdsToMove: string[];
    filterLength: number;
    installBaseIds: string[];
    showStatusChangeModal: boolean;
}

const ManageInventory: React.FC<Iprops> = (props: Iprops) => {
    const { selectedFacility } = props;
    const isMobile = useSelector(getIsMobile);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const prevFacilityIdRef = React.useRef<string>('');

    /*
     * Builds the CSV export request at click time so it reflects the current
     * facility + in-memory grid filters (search / category / status /
     * hide-virtual). Status labels are sent as a numeric-keyed map because the
     * C# status enum names differ from the front-end's (numeric values align).
     */
    const buildExportRequest = (): ExportRequest => {
        const tf: any = props.manageInventory.tableFilters;
        const mainCategoryVal =
            tf.mainCategory &&
            tf.mainCategory.value &&
            tf.mainCategory.value !== 'All'
                ? tf.mainCategory.value
                : null;
        const statusRaw =
            tf.status && typeof tf.status === 'object'
                ? tf.status.value
                : tf.status;
        const statusVal =
            statusRaw && statusRaw !== 'All' && statusRaw !== ''
                ? parseInt(statusRaw, 10)
                : null;

        const statusMap: { [raw: string]: string } = {};
        [
            measurementPointResultStatusTypesEnum.resultStatusNotTested,
            measurementPointResultStatusTypesEnum.resultStatusFail,
            measurementPointResultStatusTypesEnum.resultStatusPass,
            measurementPointResultStatusTypesEnum.resultStatusCannotComplete,
            measurementPointResultStatusTypesEnum.resultStatusRepaired,
            measurementPointResultStatusTypesEnum.resultStatusMaintain,
            measurementPointResultStatusTypesEnum.resultStatusCommissioned,
            measurementPointResultStatusTypesEnum.resultStatusNotUnderContract,
            measurementPointResultStatusTypesEnum.resultStatusDecommissioned
        ].forEach(v => {
            statusMap[String(v)] = t(
                `manageMeasurementPointLists:${measurementPointResultStatusTypesEnum[v]}`
            );
        });

        return {
            url: API.GET.inventory.exportCsv,
            body: {
                facilityID: selectedFacility.id,
                search: tf.search || undefined,
                mainCategoryID: mainCategoryVal,
                status: statusVal,
                hideVirtual: tf.hideVirtualToggle || false,
                virtualSubcategoryID: constants.virtualProductSubcategoryID,
                // Translations still flow through t(); capWords() title-cases
                // each word so headers read consistently (e.g. "serial number"
                // -> "Serial Number"). Already-cased letters and acronyms
                // (FSE/WO) are left untouched.
                columnHeaders: [
                    capWords(t('manageInventory:name')),
                    'Material ID',
                    capWords(t('serialNumber')),
                    // Reuse the existing translation key (also used by
                    // LeadInstallBasesExpander) so this header stays localized
                    // instead of being a hard-coded English string.
                    capWords(t('assetNumber')),
                    capWords(t('manageInventory:location')),
                    capWords(t('common:status')),
                    // MMG-4295: date the status to its left was recorded.
                    // Reuses the dashboard's existing label so the header stays
                    // localized without a new translation key.
                    capWords(t('dashboardAnalytics:lastInspection')),
                    'Install Base ID'
                ],
                settings: {
                    dateFormat: INVENTORY_EXPORT_DATE_FORMAT,
                    valueOverrides: { status: statusMap }
                }
            },
            filename: 'asset-details.csv'
        };
    };
    const buildSearchControls = useCallback((): FieldConfig => {
        const { tableFilters } = props.manageInventory;
        const mainSearchControls = {
            search: {
                render: FormUtil.TextInputWithoutValidation,
                meta: {
                    label: t('common:searchProduct'),
                    colWidth: isMobile ? 12 : 3,
                    type: 'text',
                    placeholder: isMobile
                        ? 'common:searchProductAssetPlaceholder'
                        : 'searchPlaceholder',
                    defaultValue: tableFilters.search
                }
            },
            mainCategory: {
                render: FormUtil.SelectWithoutValidation,
                meta: {
                    label: t('common:mainCategory'),
                    options: props.productInfo.mainCategoryOptions,
                    colWidth: isMobile ? 12 : 3,
                    type: 'select',
                    placeholder: isMobile
                        ? 'common:searchCategoryPlaceholder'
                        : 'mainCategoryPlaceholder',
                    defaultValue: tableFilters.mainCategory,
                    isClearable: true
                }
            },
            status: {
                render: FormUtil.SelectWithoutValidation,
                meta: {
                    label: t('common:status'),
                    options: FormUtil.convertEnumToOptions(
                        measurementPointResultStatusTypesEnum
                    ),
                    colWidth: isMobile ? 12 : 3,
                    type: 'select',
                    placeholder: isMobile
                        ? 'common:searchStatusPlaceholder'
                        : 'statusPlaceholder',
                    defaultValue: tableFilters.status,
                    isClearable: true,
                    shouldTranslate: true
                }
            },
            hideVirtualToggle: {
                render: FormUtil.Toggle,
                meta: {
                    label: t('common:hideVirtual'),
                    colWidth: isMobile ? 12 : 4,
                    defaultValue: tableFilters.hideVirtualToggle,
                    innerStyle: {
                        display: 'flex',
                        alignItems: 'center',

                        gap: '4px'
                    }
                }
            }
        };

        return {
            controls: { ...mainSearchControls }
        } as FieldConfig;
        // eslint-disable-next-line
    }, [
        props.productInfo.mainCategoryOptions,
        t,
        i18n.language,
        props.manageInventory
    ]);
    const [state, setState] = useState<Istate>({
        selectedRow: {},
        currentTile: emptyTile,
        showSearchNewFacilityModal: false,
        installIdsToMove: [],
        filterLength: 0,
        installBaseIds: [],
        showStatusChangeModal: false
    });

    let setTableFilterTimeout: any;

    // size the table to whatever the banner + search area really occupies
    const screenRef = useFiltersHeight([isMobile]);

    const { manageInventory } = props;
    const isManageAssetView = props.match.path === '/inventory';
    // the product search flyout fires global-loading fetches on every filter
    // change; don't let those flicker the background grid while it is open
    const backgroundLoading =
        props.loading && !manageInventory.showSearchNewProductsModal;
    const selectedProductForEditInstall = manageInventory.showSearchNewProductsModal
        ? props.searchNewProductsSelectedProduct
        : props.selectedProduct;
    const colorButton =
        constants.colors[
            `${state.currentTile.color}Button` as keyof typeof constants.colors
        ];

    const getQuantityColumn = (): Column<any> => {
        const centered = {
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' }
        };
        if (isManageAssetView) {
            return {
                Header: 'qty',
                id: 'quantity',
                width: 80,
                ...centered,
                accessor: ({ installBasesCount }: IMaterial) => {
                    return installBasesCount || 0; // using this rather than data.quantity because quantity is not working
                }
            };
        } else {
            return {
                Header: 'qty',
                id: 'quantity',
                width: 80,
                ...centered,
                accessor: ({ workOrders }: IinstallBasePopulated) => {
                    return workOrders.length || 0; // using this rather than data.quantity because quantity is not working
                }
            };
        }
    };

    const getNameColumn = (): Column<any> => {
        if (isManageAssetView) {
            return {
                Header: t('manageInventory:name'),
                id: 'name',
                accessor: (inventory: IMaterial) => inventory.name,
                minWidth: 400
            };
        } else {
            return {
                Header: t('manageInventory:name'),
                id: 'name',
                accessor: (inventory: IinstallBasePopulated) => {
                    return (
                        <span
                            className={`${
                                inventory.sapEquipmentNumber ? 'blue-bold' : ''
                            }`}
                        >
                            {inventory.productNameString}
                        </span>
                    );
                },
                minWidth: 400
            };
        }
    };

    const columns = () =>
        TableUtil.translateHeaders(
            [
                {
                    id: 'expander-toggle',
                    expander: true,
                    Expander: TableUtil.expanderToggle,
                    style: {
                        cursor: 'pointer',
                        textAlign: 'left',
                        userSelect: 'none'
                    }
                },
                getNameColumn(),
                getQuantityColumn()
            ],
            t
        );

    const mobileColumns = () =>
        TableUtil.translateHeaders(
            [
                {
                    Header: t('manageInventory:name'),
                    id: 'name',
                    accessor: inventory => {
                        const name = [];

                        name.push(inventory.name);

                        if (inventory.number) {
                            name.push(inventory.number);
                        }

                        if (inventory.description) {
                            name.push(inventory.description);
                        }

                        return name.join(': ');
                    }
                },
                getQuantityColumn()
            ],
            t
        );

    // Close all modals on component dismount.
    // Prior to this you could leave the page with the modal open and go to a new page where a
    // disembodied modal might be open.
    React.useEffect(() => {
        return () => {
            dispatch({ type: HIDE_MODAL_SEARCH_NEW_PRODUCTS });
            dispatch({ type: HIDE_MODAL_EDIT_PRODUCT });
        };
        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        setState(currState => ({
            ...currState,
            filterLength: Object.keys(buildSearchControls().controls).length
        }));
    }, [buildSearchControls]);

    React.useEffect(() => {
        props.getProductInfo();

        if (selectedFacility.id.length) {
            // Only reset filters if facility actually changed (not on mount)
            if (
                prevFacilityIdRef.current &&
                prevFacilityIdRef.current !== selectedFacility.id
            ) {
                props.setTableFilter({
                    search: '',
                    mainCategory: undefined,
                    status: undefined,
                    page: 0
                });
            }
            prevFacilityIdRef.current = selectedFacility.id;

            props.initInventory(
                selectedFacility.id,
                () => {
                    return;
                },
                1
            );
            props.getFacility(selectedFacility.id);
            dispatch(getWorkOrders());
        }

        setState({
            ...state,
            currentTile: constants.getTileByURL(props.location.pathname),
            selectedRow: {}
        });
        // eslint-disable-next-line
    }, [selectedFacility.id]);

    // auto scroll to top when data changes and handle auto-expansion
    React.useEffect(() => {
        const tableElement = document.querySelector('.ReactTable .rt-tbody');
        if (tableElement) tableElement.scrollTop = 0;

        // Check if navigation came with autoExpand flag (from AssetOverview)
        const locationState = props.location.state as
            | { autoExpand?: boolean }
            | undefined;
        const shouldAutoExpand = locationState?.autoExpand === true;

        // Check if any filters are active
        const {
            search,
            mainCategory,
            status
        } = props.manageInventory.tableFilters;
        const hasActiveFilters =
            (search && search.length > 0) ||
            mainCategory !== undefined ||
            status !== undefined;

        if (
            shouldAutoExpand &&
            hasActiveFilters &&
            props.tableData.length > 0
        ) {
            // Auto-expand all rows when navigated from AssetOverview with filters
            const expandedRows: { [key: number]: boolean } = {};
            props.tableData.forEach((_: any, index: number) => {
                expandedRows[index] = true;
            });
            setState(prevState => ({
                ...prevState,
                selectedRow: expandedRows
            }));

            // If only one result, set it as selected product
            if (props.tableData.length === 1) {
                props.setSelectedProductID(props.tableData[0].id);
            }

            // Clear the autoExpand flag from location state so it doesn't persist
            if (locationState?.autoExpand) {
                props.history.replace({
                    ...props.location,
                    state: { ...locationState, autoExpand: false }
                });
            }
        } else {
            // Clear selected row when table data changes (existing behavior)
            setState(prevState => ({ ...prevState, selectedRow: {} }));
        }
        // eslint-disable-next-line
    }, [
        props.tableData.length,
        props.manageInventory.tableFilters.search,
        props.manageInventory.tableFilters.mainCategory,
        props.manageInventory.tableFilters.status
    ]);

    /*
     * Handle user clicking on a product row column
     * set the selected product to state and open the modal
     */
    const getTdProps = (
        stateFinal: FinalState,
        rowInfo: RowInfo | undefined,
        column: Column | undefined,
        instance: any
    ) => {
        if (rowInfo && column) {
            return {
                onClick: (e: React.MouseEvent<HTMLFormElement>) => {
                    if (column.id && column.id === 'actions') {
                        return;
                    }
                    setState({
                        ...state,
                        selectedRow: {
                            [rowInfo.viewIndex || 0]: !state.selectedRow[
                                rowInfo.viewIndex || 0
                            ]
                        }
                    });
                    if (!state.selectedRow[rowInfo.viewIndex || 0]) {
                        props.setSelectedProductID(rowInfo.original.id);
                    } else {
                        props.clearSelectedProductID();
                    }
                },
                style: {
                    background: state.selectedRow[rowInfo.viewIndex]
                        ? constants.colors[
                              `${state.currentTile.color}Tr` as keyof typeof constants.colors
                          ]
                        : ''
                }
            };
        } else {
            return {};
        }
    };

    const getTdPropsMobile = (
        stateFinal: FinalState,
        rowInfo: RowInfo | undefined,
        column: Column | undefined,
        instance: any
    ) => {
        if (rowInfo && column) {
            // launch manage inventory details component

            return {
                onClick: (e: React.MouseEvent<HTMLFormElement>) => {
                    setState({
                        ...state,
                        selectedRow: {
                            [rowInfo.viewIndex || 0]: !state.selectedRow[
                                rowInfo.viewIndex || 0
                            ]
                        }
                    });
                },
                style: {
                    background: state.selectedRow[rowInfo.viewIndex]
                        ? constants.colors[
                              `${state.currentTile.color}Tr` as keyof typeof constants.colors
                          ]
                        : ''
                }
            };
        } else {
            return {};
        }
    };

    /*
     * (reusable)
     * set the table filters to redux on each value change
     */
    const onSearchValueChanges = (value: any, key: string) => {
        switch (key) {
            case 'search':
                clearTimeout(setTableFilterTimeout);
                setTableFilterTimeout = setTimeout(() => {
                    props.setTableFilter({ search: value, page: 0 }); // this causes performance issues so we use a rudamentary debounce
                }, constants.tableSearchDebounceTime);
                break;
            case 'mainCategory':
                props.setTableFilter({
                    mainCategory:
                        value && value !== 'All'
                            ? { value, label: '' }
                            : undefined,
                    page: 0
                });
                break;
            case 'status':
                props.setTableFilter({
                    status: value && value !== 'All' ? value : undefined,
                    page: 0
                });
                break;
            case 'hideVirtualToggle':
                props.setTableFilter({ hideVirtualToggle: value, page: 0 });
                break;
            default:
                break;
        }
    };

    const onSortedChanged = (
        newSorted: SortingRule[],
        column: any,
        shiftKey: boolean
    ) => {
        props.setTableFilter({ sorted: newSorted });
        setState({ ...state, selectedRow: {} });
    };

    /*
     * Handle Product Select from the search new products modal
     */
    const handleSearchNewProductSelect = (
        product: IMaterial,
        installBatchMode: IsearchNewProductInstallBatchMode
    ) => {
        if (installBatchMode.isBatchMode) {
            toastr.confirm(
                props.t('toastMessage:confirmBulkChangeProduct', {
                    count: installBatchMode.installBaseIDs.length
                }),
                {
                    onOk: () => {
                        dispatch(
                            bulkUpdateInstallProducts(
                                product,
                                installBatchMode.installBaseIDs
                            )
                        );
                    }
                }
            );
            return;
        }
        props.toggleEditInstallModal();
        props.setSearchNewProductsSelectedProduct(product);
    };

    /*
     * Handle Merge Product
     */
    const handleMergeProduct = (product: IMaterial) => {
        toastr.confirm(
            `${props.t('manageProductQueue:mergeConfirmPart_01')} \n \n${
                props.selectedProduct.name
            } \n \n ${props.t(
                'manageProductQueue:mergeConfirmPart_02'
            )} \n \n ${product.name}?`,
            {
                onOk: () => {
                    props
                        .mergeProduct(props.selectedProduct.id, product.id)
                        .then(() => {
                            props.initInventory(
                                props.selectedFacility.id,
                                () => {
                                    return;
                                },
                                1
                            );
                            setState({ ...state, selectedRow: {} });
                        })
                        .catch((error: any) => console.error(error));
                }
            }
        );
    };

    const moveFacility = async (newFacilityId: string) => {
        if (state.installIdsToMove.length > 0) {
            const response = await moveFacilitiesAPI(
                newFacilityId,
                state.installIdsToMove
            );
            if (response) {
                setState({
                    ...state,
                    installIdsToMove: [],
                    showSearchNewFacilityModal: false,
                    selectedRow: {}
                });

                toastr.success(
                    props.t('Success'),
                    props.t('Install Bases successfully merged'),
                    constants.toastrSuccess
                );

                // Refresh the table
                props.initInventory(
                    props.selectedFacility.id,
                    () => {
                        return;
                    },
                    1,
                    true
                );
            } else {
                toastr.warning(
                    props.t('Error'),
                    props.t('Failed to merge Install Bases'),
                    constants.toastrError
                );
            }
        } else {
            toastr.warning(
                props.t('Error'),
                props.t('No install bases were selected'),
                constants.toastrError
            );
        }
    };

    const hideNewFacilitiesModal = () => {
        setState({ ...state, showSearchNewFacilityModal: false });
    };

    const showNewFacilityModal = (ids: string[]) => {
        setState({
            ...state,
            showSearchNewFacilityModal: true,
            installIdsToMove: ids
        });
    };

    const showStatusChangeModal = (ids: string[]) => {
        setState(prev => ({
            ...prev,
            installBaseIds: ids,
            showStatusChangeModal: true
        }));
    };

    const onStatusChangeSuccess = () => {
        setState((prev: Istate) => ({
            ...prev,
            showStatusChangeModal: false,
            installBaseIds: []
        }));

        props.initInventory(
            props.selectedFacility.id,
            () => {
                return;
            },
            1
        );
    };

    // Map the persisted filter values to full option objects for UI dropdowns
    const currentCategoryOption = React.useMemo(() => {
        const categoryValue = props.manageInventory.tableFilters.mainCategory;
        if (!categoryValue) return null;

        // Find the full option to get the label
        const found = props.productInfo.mainCategoryOptions?.find(
            opt => opt.value?.toString() === categoryValue.value?.toString()
        );

        return found
            ? { value: found.value?.toString() || '', label: found.label || '' }
            : null;
    }, [
        props.manageInventory.tableFilters.mainCategory,
        props.productInfo.mainCategoryOptions
    ]);

    const currentStatusOption = React.useMemo(() => {
        const statusValue = props.manageInventory.tableFilters.status;
        if (!statusValue) return null;

        // Handle both string and object formats
        const statusString =
            (statusValue as any).value?.toString() ?? statusValue.toString();

        if (statusString === 'All') return null;

        const statusOptions = FormUtil.convertEnumToOptions(
            measurementPointResultStatusTypesEnum
        );
        const found = statusOptions.find(
            opt => opt.value?.toString() === statusString
        );

        return found
            ? {
                  value: found.value?.toString() || '',
                  label: t(`manageMeasurementPointLists:${found.label}`) || ''
              }
            : null;
    }, [props.manageInventory.tableFilters.status, t]);

    // For mobile, if a row is selected, show the ManageInventoryDetails component
    if (isMobile) {
        const key = Object.keys(state.selectedRow);

        if (key.length > 0) {
            const first = key[0];
            const convertedInt = parseInt(first);
            if (!isNaN(convertedInt)) {
                return (
                    <div
                        className={`manage-inventory`}
                        style={{
                            ['--filter-size' as string]: state.filterLength
                        }}
                    >
                        <ManageInventoryDetails
                            selectedProduct={props.tableData[convertedInt]}
                            t={props.t}
                            colorButton={colorButton}
                            facility={props.selectedFacility}
                            openSearchFacilityModal={() => {
                                return;
                            }}
                            goBack={() => {
                                setState({ ...state, selectedRow: {} });
                            }}
                            setSelectedInstallBaseID={
                                props.setSelectedInstallBaseID
                            }
                            setSelectedProductID={props.setSelectedProductID}
                            toggleEditInstallModal={
                                props.toggleEditInstallModal
                            }
                        />

                        <MPResultListMobileModal
                            colorButton={colorButton}
                            secondModal={false}
                            locationString={TableUtil.buildLocation(
                                props.selectedInstallBase,
                                props.selectedFacility
                            )}
                            selectedMeasurementPointResultID={
                                props.selectedInstallBase
                                    .latestMeasurementPointListResultID
                            }
                        />

                        <MPResultHistoryMobileModal
                            colorButton={colorButton}
                            secondModal={false}
                            locationString={TableUtil.buildLocation(
                                props.selectedInstallBase,
                                props.selectedFacility
                            )}
                            selectedInstallBaseID={props.selectedInstallBase.id}
                        />

                        <MPResultListNotesMobileModal
                            colorButton={colorButton}
                            secondModal={true}
                        />

                        <EditInstallModal
                            colorButton={colorButton}
                            selectedProduct={selectedProductForEditInstall}
                        />

                        <EditWorkOrderModal
                            colorButton={colorButton}
                            secondModal={true}
                        />

                        <InstallContactModal colorButton={colorButton} />
                    </div>
                );
            }
        }
    }

    const scrollingHeight = isMobile ? 'calc(100dvh - 60px - 84px)' : '100%';
    const overFlow = isMobile ? 'auto' : 'initial';

    // Calculate dynamic page sizes based on filtered data length
    const desktopPageSize =
        props.tableData.length > 0
            ? Math.min(props.tableData.length, 100)
            : 100;

    const mobilePageSize =
        props.tableData.length > 0
            ? Math.min(
                  props.tableData.length,
                  manageInventory.tableFilters.rows ||
                      constants.tablePageSizeDefault
              )
            : manageInventory.tableFilters.rows ||
              constants.tablePageSizeDefault;

    return (
        <div
            className={`manage-inventory ${props.className}`}
            ref={screenRef}
            style={{
                ['--filter-size' as string]: state.filterLength
            }}
        >
            <Banner
                title={t(props.bannerTitle)}
                img={state.currentTile.srcBanner}
                color={state.currentTile.color}
            >
                {props.canRequestQuote && props.match.path !== '/assetStatus' && (
                    <Button
                        className="request-for-quote-cart-button"
                        bsStyle="primary"
                        onClick={() =>
                            props.toggleShoppingCartModal('INVENTORY')
                        }
                    >
                        <FontAwesomeIcon icon={['fas', 'shopping-cart']} />
                        <Badge>{props.cartTotal} </Badge>
                    </Button>
                )}
            </Banner>

            <div style={{ height: scrollingHeight, overflowY: overFlow }}>
                <NewInventorySearch
                    t={t}
                    getExportRequest={buildExportRequest}
                    colorButton={colorButton}
                    canEditInstalls={props.canEditInstalls}
                    isManageAssetView={isManageAssetView}
                    loading={backgroundLoading}
                    onImportClick={props.toggleImportInstallModal}
                    onNewProductClick={() => {
                        props.clearSelectedProductID();
                        props.clearSelectedInstallBaseID();
                        props.toggleSearchNewProductsModal();
                    }}
                    onBackClick={() => {
                        props.history.goBack();
                    }}
                    onSearchChange={value =>
                        onSearchValueChanges(value, 'search')
                    }
                    onCategoryChange={value =>
                        onSearchValueChanges(value, 'mainCategory')
                    }
                    onStatusChange={value =>
                        onSearchValueChanges(value, 'status')
                    }
                    onSearchValueChanges={onSearchValueChanges}
                    currentSearch={props.manageInventory.tableFilters.search}
                    currentCategory={currentCategoryOption}
                    currentStatus={currentStatusOption}
                    categoryOptions={
                        props.productInfo.mainCategoryOptions?.map(option => ({
                            value: option.value?.toString() || '',
                            label: option.label || ''
                        })) || []
                    }
                    statusOptions={FormUtil.convertEnumToOptions(
                        measurementPointResultStatusTypesEnum
                    ).map(option => ({
                        value: option.value?.toString() || '',
                        label:
                            t(`manageMeasurementPointLists:${option.label}`) ||
                            ''
                    }))}
                    hideDecommissionedAssets={
                        manageInventory.tableFilters.hideVirtualToggle || false
                    }
                    onHideAssetsToggle={value =>
                        props.setTableFilter({
                            hideVirtualToggle: value,
                            page: 0
                        })
                    }
                />

                {/* <SearchTableForm
                    fieldConfig={searchFieldConfig}
                    handleSubmit={props.initInventory}
                    loading={props.loading}
                    colorButton={colorButton}
                    subscribeValueChanges={true}
                    onValueChanges={onSearchValueChanges}
                    t={props.t}
                    showSearchButton={false}
                >
                    {!isMobile && (
                        <>
                            {props.canEditInstalls && isManageAssetView && (
                                <div>
                                    <Button
                                        className="table-import-button"
                                        bsStyle="link"
                                        onClick={props.toggleImportInstallModal}
                                    >
                                        {t('manageInventory:import')}
                                    </Button>

                                    <Button
                                        className="table-add-button"
                                        bsStyle="link"
                                        onClick={() => {
                                            props.clearSelectedProductID();
                                            props.clearSelectedInstallBaseID();
                                            props.toggleSearchNewProductsModal();
                                        }}
                                    >
                                        {t('manageInventory:newProduct')}
                                    </Button>
                                </div>
                            )}
                            {isManageAssetView === false && (
                                <LinkContainer to="/dashboard">
                                    <Button
                                        bsStyle="link"
                                        className="table-add-button"
                                    >
                                        <FontAwesomeIcon icon={['fas', 'chevron-left']} />{' '}
                                        {t('common:backButton')}
                                    </Button>
                                </LinkContainer>
                            )}
                        </>
                    )}
                </SearchTableForm> */}

                {/* MOBILE */}
                {isMobile && (
                    <ReactTable
                        data={props.tableData}
                        columns={mobileColumns()}
                        getTdProps={getTdPropsMobile}
                        defaultPageSize={mobilePageSize}
                        pageSize={mobilePageSize}
                        page={manageInventory.tableFilters.page}
                        onPageChange={pageIndex =>
                            props.setTableFilter({ page: pageIndex })
                        }
                        showPageSizeOptions={true}
                        className={`beacon-table -highlight ${state.currentTile.color}`}
                        previousText={t('common:previous')}
                        nextText={t('common:next')}
                        onSortedChange={onSortedChanged}
                        sortable={false}
                        multiSort={false}
                        noDataText={t('common:noDataText')}
                        resizable={false}
                        loading={backgroundLoading}
                    />
                )}
            </div>

            {/* DESKTOP */}
            {!isMobile && (
                <ReactTable
                    data={props.tableData}
                    columns={columns()}
                    getTdProps={getTdProps}
                    defaultPageSize={100}
                    pageSize={desktopPageSize}
                    page={manageInventory.tableFilters.page}
                    onPageChange={pageIndex => {
                        // collapse expanded rows: expansion is keyed by row
                        // position, so leaving it set would show the wrong
                        // product expanded (with a stale checkbox selection)
                        setState(prev => ({ ...prev, selectedRow: {} }));
                        props.setTableFilter({ page: pageIndex });
                    }}
                    showPageSizeOptions={false}
                    className={`beacon-table -highlight ${state.currentTile.color}`}
                    previousText={t('common:previous')}
                    nextText={t('common:next')}
                    pageText={t('common:pageText')}
                    rowsText={t('common:rowsText')}
                    onSortedChange={onSortedChanged}
                    sortable={false}
                    multiSort={false}
                    noDataText={t('common:noDataText')}
                    SubComponent={(rowInfo: RowInfo) => {
                        if (isManageAssetView === false) {
                            return (
                                <WorkOrderExpander {...rowInfo} t={props.t} />
                            );
                        }
                        return (
                            <InstallBasesExpanderContainer
                                {...rowInfo}
                                t={props.t}
                                colorButton={colorButton}
                                openSearchFacilityModal={showNewFacilityModal}
                                openStatusChangeModal={showStatusChangeModal}
                            />
                        );
                    }}
                    resizable={false}
                    expanded={state.selectedRow}
                    loading={backgroundLoading}
                />
            )}

            <EditProductModal
                selectedItem={props.selectedProduct || initialMaterial}
                colorButton={colorButton}
                secondWideModal={
                    manageInventory.showSearchNewProductsModal === true &&
                    props.selectedProduct.id.length === 0
                }
                selectedQueueObject={initialProductQueueObject}
            />
            <ShoppingCartModal
                colorButton={colorButton}
                t={props.t}
                cart={manageInventory.cart}
                title={props.t('manageInventory:requestForQuote')}
                checkout={props.requestQuote}
                cartName="INVENTORY"
                ShoppingCartForm={ShoppingCartForm}
                showCost={false}
            />
            <EditInstallModal
                colorButton={colorButton}
                selectedProduct={selectedProductForEditInstall}
            />
            <InstallContactModal colorButton={colorButton} />

            <SearchNewProductsModal
                selectedItem={props.selectedProduct}
                colorButton={colorButton}
                handleProductSelect={handleSearchNewProductSelect}
                handleMergeProduct={handleMergeProduct}
                // If we are in batch mode, then we don't want to enable merge product mode.
                // we also don't want it to show up as a second modal.
                secondModal={
                    props.manageInventory.searchNewProductInstallBatchMode
                        .isBatchMode
                        ? false
                        : props.selectedProduct.id.length !== 0
                }
                enableMergeProductMode={
                    props.manageInventory.searchNewProductInstallBatchMode
                        .isBatchMode
                        ? false
                        : props.selectedProduct.id.length !== 0
                }
                wideModal={true}
                isApproved={props.selectedProduct.id.length !== 0}
                disableCreateNew={false}
            />
            <ImportInstallModal colorButton={colorButton} />
            <MPResultListModal
                colorButton={colorButton}
                secondModal={false}
                locationString={TableUtil.buildLocation(
                    props.selectedInstallBase,
                    props.selectedFacility
                )}
                selectedMeasurementPointResultID={
                    props.selectedInstallBase.latestMeasurementPointListResultID
                }
            />
            <MPResultHistoryModal
                colorButton={colorButton}
                secondModal={false}
                locationString={TableUtil.buildLocation(
                    props.selectedInstallBase,
                    props.selectedFacility
                )}
                selectedInstallBaseID={props.selectedInstallBase.id}
            />
            {/* the history modal is a 500px wide-modal, so modals opened from it
                need the wider second-modal offset to sit beside it (MMG-4381) */}
            <EditWorkOrderModal
                colorButton={colorButton}
                secondWideModal={props.manageInventory.showMPResultHistoryModal}
            />
            <MPResultListNotesModal
                colorButton={colorButton}
                secondModal={!props.manageInventory.showMPResultHistoryModal}
                secondWideModal={props.manageInventory.showMPResultHistoryModal}
            />

            <WorkOrderCloseModal
                colorButton={colorButton}
                selectedInstallBaseID={props.selectedInstallBase.id}
                enableRepairMode={true}
                secondModal={false}
            />

            <SearchNewFacilityModal
                showModal={state.showSearchNewFacilityModal}
                hideModal={hideNewFacilitiesModal}
                colorButton={colorButton}
                moveFacility={moveFacility}
            />
            <BulkStatusChangeModal
                show={state.showStatusChangeModal}
                onHide={() =>
                    setState(prev => ({
                        ...prev,
                        showStatusChangeModal: false,
                        installBaseIds: []
                    }))
                }
                colorButton="primary"
                secondModal={false}
                installBaseIds={state.installBaseIds}
                onSuccess={onStatusChangeSuccess}
            />
        </div>
    );
};

export default ManageInventory;
